import { render, staticRenderFns } from "./StadiumFieldCreateAndUpdateFormItems.vue?vue&type=template&id=57e5826e&"
import script from "./StadiumFieldCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./StadiumFieldCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports